// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../library/utils/NetworkUtils.bs.js";
import * as Logger$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TrackLiveTripRepoConfig from "./TrackLiveTripRepoConfig.bs.js";

var dummyTrackLiveTripInfo = {
        "order_details": {
          "order_id": "CRN59849505",
          "reallocated_order_id": null,
          "status": "open",
          "payment_mode": "cash",
          "is_postpaid": true,
          "has_toll": false,
          "distance": 17.89,
          "previous_due": 0.0,
          "total_discount": 0.0,
          "pickup_time": 1600222613,
          "toll_amount": 0.0,
          "customer_info": {
            "customer_id": 2160412,
            "customer_mobile": "9769547707",
            "name": "Nashir n customer",
          },
          "booking_number": "9769547707",
          "business_type": "Other essential goods",
          "create_trip_fare_strategy": "fixed_pricing",
          "estimated_trip_fare": 649,
          "estimated_partner_trip_fare": 649,
          "vehicle": {
            "icons": {
                "map_marker": "https://porter-customer-app-promo-images-prod.s3.amazonaws.com/Map+icon+front+view/4wheeler_front-xxxhdpi.png",
                "selected": "https://porter-vehicles.s3-ap-southeast-1.amazonaws.com/icon-images/tata_ace_filled.png",
                "deselected": "https://porter-vehicles.s3-ap-southeast-1.amazonaws.com/icon-images/tata_ace_outlined.png"
            },
            "vehicle_url" : "https://img.favpng.com/11/22/9/car-truck-commercial-vehicle-icon-png-favpng-gPBXwGHW6JDUEduF8ggwnH0XG.jpg",
            "vehicle_type": "2 wheeler",
            "vehicle_id": 1,
            "size": "7ft x 4.5ft x 5.5ft",
            "capacity": "750 kg",
            "free_waiting_mins": 70,
            "travel_rate_per_min": 3.0,
            "waiting_rate_per_min": 3.5,
          },
          "pickup_info": {
            "place": {
              "landmark": "8, 90 Feet Rd, Krishna Nagar, Sathi D Souza Nagar, Saki Naka, Mumbai, Maharashtra 400072, India",
              "location": {
                "lat": 19.0972510636143,
                "long": 72.8881760314107,
              },
            },
            "contact": {
              "name": "Nashir Pickup Name",
              "number": "9769547707",
            },
          },
          "has_waypoints": true,
          "waypoints": [
             {
               "place": {
                 "location": {
                   "lat": 19.295713,
                   "long": 72.848410,
                 },
                 "landmark": "Concorde Silicon Valley, Electronics City Phase 1, Electronic City, Karnataka, India Concorde Silicon Valley, Electronics City Phase 1, Electronic City, Karnataka, India Concorde Silicon Valley, Electronics City Phase 1, Electronic City, Karnataka, India Concorde Silicon Valley, Electronics City Phase 1, Electronic City, Karnataka, India",
               },
               "contact": {
                 "name": "atul kamath",
                 "number": "9731592801",
               },
             },
             {
               "place": {
                 "location": {
                   "lat": 29.3482510,
                   "long": 85.798176,
                 },
                 "landmark": "Concorde Silicon Valley, Electronics City Phase 1, Electronic City, Karnataka, India",
               },
               "contact": {
                 "name": "atul kamath",
                 "number": "9731592801",
               },
             },
          ],
          "order_type": "rental",
          "geo_region_id": 1,
          "is_helper_order": true,
          "is_outstation_order": false,
          "partner_info": {
            "name": "Mohd Salim Mohammed Ali Nashir Shah",
            "vehicle_number": "MH-03-CV-2956",
            "vehicle_type": "2 Wheeler",
            "mobile": "9819474966",
            "partner_secondary_mobile": "9137096004",
            "driver_msisdn": "9819474966956",
            "has_nep": false,
            "fuel_type": "unknown",
          },
          "drop_info": {
            "place": {
              "landmark": "JJ Hospital Mumbai, Mohammed Ali Road, Mazgaon, Mumbai, Maharashtra, India",
              "location": {
                "lat": 19.0366733,
                "long": 72.8327624,
              },
            },
            "contact": {
              "name": "Nashir n",
              "number": "9769547707",
            },
          },
          "trip_accepted_time": 1600222072,
          "trip_accepted_location": "POINT (72.8856163 19.094678)",
          "trip_ended_time": 1759080083,
          "partner_location": {
            "lat": 19.0946458,
            "long": 72.8856103,
          },
          "trip_started_time": 1658749111,
        },
        "config": {
          "customer_care_number": "2244104410",
        },
      };

var dummyMarketingInfo = { "marketing_info": {
        "savings_amount": 11.5,
        "average_eta": 1270,
        "registered_partners": 888,
        "average_booking_time": 30,
        "download_app_link":"https://oms-staging-1.porter.in/customerapplinks/registration_via_track_live?referral_code=AKA6MD\u0026referrer=8a2995a3-ebf8-4264-a85d-6e2c51d64659\u0026order_id=CRN79966950",
        "referral_discount_info": {
          "discount_amount": 200,
          "n_tickets": 2,
          "discount_code": "WOWOWOW",
        },
        "coupon_discount_info":{
          "discount_amount": 200,
          "n_tickets": 2,
          "discount_code": "WOWOWOW",
        },
      }};

function fetchTrackLiveTripInfo(booking_id, _customer_uuid) {
  Logger$Catalyst.trace({
        requestUrl: "fetchTrackLiveTripInfoApiCalled"
      });
  Logger$Catalyst.debug({
        payload: booking_id
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyTrackLiveTripInfo
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TrackLiveTripRepoConfig.TrackLiveTripResponseConverter.execute, result);
                            });
                }), "");
}

function fetchTrackLiveTripMarketingInfo(booking_id, _customer_uuid) {
  Logger$Catalyst.trace({
        requestUrl: "fetchTrackLiveTripMarketingInfoApiCalled"
      });
  Logger$Catalyst.debug({
        payload: booking_id
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyMarketingInfo
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TrackLiveTripRepoConfig.TrackLiveTripPromoResponseConverter.execute, result);
                            });
                }), "");
}

var dummyCityResponse = {
    "name": "Bangalore",
    "id": 3,
    "description": "For the people of the Garden City or recently turned Silicon Valley, Bangalore Porter brings to you a fleet of vehicles ranging from 2W/3W/4W/8feet pickup to help you with intra-city logistics. These tempo trucks will help you transport & deliver goods for both personal and commercial purposes.",
    "description_2": "The vehicles are suited for small/medium sized businesses as well and Porter also offers an enterprise solution for businesses to look into. The 2W service would help send goods within the city instantly. With Porter, you receive verified drivers, real-time location information & transparent pricing model. Be it transporting textiles, textile machinery, auto components, steel, aluminium, pumps and motors or shifting house, furniture and luggage, Porter has a solution for all. Just download the app and rent a vehicle.",
    "fleet_list": [
        {
            "id": 24,
            "display_name": "3 Wheeler",
            "vehicle_type": "3 Wheeler",
            "geo_region": {
                "id": 3,
                "name": "Bangalore"
            },
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/3_wheeler-022fc2284832545607afeea8be6e567e0d2e99ff2e4e035e4f66374b22fa92db.png",
            "image_alt_text": "Mini Truck 3 Wheeler in Bangalore",
            "vehicle_icon_url": "https://oms-staging-1.porter.in//assets/website_revamp/vehicle_icons/3_wheeler-2851d98cd714e08c3e1aad00a2b1546ad9f360c157b06fb21ecd82f69eaed7db.svg",
            "description": "Looking to send across small-medium sized goods within the busy city of Bangalore? Simply Porter it with our 3 wheeler auto tempo. With the 3 wheeler auto tempo carrier, you can move around small sized household equipment, medical supplies in bulk or even fruits & vegetables. The tempo carrier service is available online for both individuals and businesses. You can book the rental 3 wheeler service and get verified drivers, real-time location sharing access & transparent pricing.\nAt Porter, we understand your logistics requirements and have suitable solutions for it. Book Porter 3 wheeler now and enjoy hassle free services.",
            "capacity": {
                "value": 1000,
                "unit": "kg"
            },
            "capacity_display": "1000kg",
            "size": {
                "length": {
                    "value": 7.2,
                    "unit": "ft"
                },
                "breadth": {
                    "value": 4.9,
                    "unit": "ft"
                },
                "height": {
                    "value": 4.9,
                    "unit": "ft"
                },
                "type": "goods_vehicle"
            },
            "size_display": "7.2ft x 4.9ft x 4.9ft",
            "base_fare": {
                "value": 300,
                "currency": "rupee"
            },
            "base_fare_display": "₹300",
            "free_time_distance_text": "Base fare includes 2.0 km distance and 60 minutes of time",
            "url": "/rent-mini-trucks-in-bangalore/3-wheeler",
            "css_class": "three_wheeler",
            "rental_package": null,
            "snippet_details": {
                "heading_text": "Transport rate for 3 Wheeler in Bangalore",
                "content": "When you book a three wheeler rental auto carrier vehicle with Porter, you not only sign up for effective logistics solutions, but also receive a transparent pricing policy.  Let your business grow with Porter & deliver your goods at the best tempo bhada charges. Base rate starts from ₹300, which includes 2.0 km distance and 60 minutes waiting time.Pricing may vary based on your locality. GST charges, road tax & parking etc are applicable over and above the ride fare. Book Porter’s 3 wheeler auto tempo services now!"
            }
        },
        {
            "id": 1,
            "display_name": "Tata Ace mini",
            "vehicle_type": "Tata Ace",
            "geo_region": {
                "id": 3,
                "name": "Bangalore"
            },
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_ace_closed-e92a36b3508e6e3b1804fd2015adbfb6c948bc35afab36699440785ed83b5b24.png",
            "image_alt_text": "Mini Truck Tata Ace mini in Bangalore",
            "vehicle_icon_url": "https://oms-staging-1.porter.in//assets/website_revamp/vehicle_icons/tata_ace-0ef1cc8a772e4180aa010c40bf34202934ab66bbbfd00f241f8182acc70cac59.svg",
            "description": "Bangalore being the capital city of Karnataka, has a population of over 8 million people! With traffic congestion it is difficult to manuver big trucks in the city.  However, a compact tempo transport like Tata Ace can easily help you move goods from one place to another.\nYou can book Tata Ace online through Porter and get a truck for local house shifting at a reasonable price. Booking a Tata Ace rental can help you with furniture transport, sofa and cupboard shifting, moving refrigerator, baggage shipping, etc. Overall, it’s among the best vehicles for house shifting. Additionally, the vehicle is also suitable for transporting commercial goods within the city.",
            "capacity": {
                "value": 750,
                "unit": "kg"
            },
            "capacity_display": "750kg",
            "size": {
                "length": {
                    "value": 7,
                    "unit": "ft"
                },
                "breadth": {
                    "value": 4.5,
                    "unit": "ft"
                },
                "height": {
                    "value": 6,
                    "unit": "ft"
                },
                "type": "goods_vehicle"
            },
            "size_display": "7ft x 4.5ft x 6ft",
            "base_fare": {
                "value": 120,
                "currency": "rupee"
            },
            "base_fare_display": "₹120",
            "free_time_distance_text": "Base fare includes 4.0 km distance and 2 minutes of time",
            "url": "/rent-mini-trucks-in-bangalore/tata-ace",
            "css_class": "tata_ace_mini",
            "rental_package": null,
            "snippet_details": {
                "heading_text": "Transport rate for Tata Ace in Bangalore",
                "content": "For all your logistics needs, Porter is here. Good for goods. With hassle free services, realtime tracking, transparent pricing & safe & reliable transportation, we service you with nothing but the best. Get tata ace tempo bhada for your intra city, inter city or outstation goods delivery even before you book thevehicle. Get best moving prices per km and per day using Porter app. Base rate starts from ₹120, which includes 4.0 km distance and 2 waiting time.\nPricing may vary based on your locality. GST charges, road tax & parking etc are applicable over and above the ride fare.\nDownload the Porter app & get the exact transportation charges!"
            }
        },
        {
            "id": 83,
            "display_name": "2 wheeler test",
            "vehicle_type": "2 Wheeler",
            "geo_region": {
                "id": 3,
                "name": "Bangalore"
            },
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_ace_closed-e92a36b3508e6e3b1804fd2015adbfb6c948bc35afab36699440785ed83b5b24.png",
            "image_alt_text": "Mini Truck 2 wheeler test in Bangalore",
            "vehicle_icon_url": "https://oms-staging-1.porter.in//assets/website_revamp/vehicle_icons/tata_ace-0ef1cc8a772e4180aa010c40bf34202934ab66bbbfd00f241f8182acc70cac59.svg",
            "description": "Forgot your documents at home and need them urgently in the office? Or need to send some packages sent to your customer urgently? With Porter two wheeler, you no longer need to get stuck in Bangalore traffic. Book Porter bike service & get a bike in 15 mins. The 2 wheeler fast deliveries services can be booked to transport both personal and commercial packages. Home bakers, Designers, home-grown jewellery brands & many more can book Porter two wheeler service, at the best costs as well.",
            "capacity": {
                "value": 20,
                "unit": "kg"
            },
            "capacity_display": "20kg",
            "size": {
                "length": {
                    "value": 40,
                    "unit": "cm"
                },
                "breadth": {
                    "value": 40,
                    "unit": "cm"
                },
                "height": {
                    "value": 40,
                    "unit": "cm"
                },
                "type": "goods_vehicle"
            },
            "size_display": "40cm x 40cm x 40cm",
            "base_fare": {
                "value": 55,
                "currency": "rupee"
            },
            "base_fare_display": "₹55",
            "free_time_distance_text": "Base fare includes 2.0 km distance and 10 minutes of time",
            "url": "/bike-parcel-delivery-bangalore",
            "css_class": "two_wheeler",
            "rental_package": null,
            "snippet_details": {
                "heading_text": "Bike parcel delivery & local courier charges in Bangalore",
                "content": "Don’t let your goods get stuck in the city’s infamous traffic, just book Porter 2 wheeler to send across your small packages weighing upto 20kgs. Need to get groceries delivered urgently to your clients, send via Porter 2 wheeler. Looking for someone to pick up & drop your hard drivers from the office? Choose Porter 2 wheeler. It’s really that simple. Door to door delivery service at the best transparent rates. Base rate starts from ₹55, which includes 2.0 km distance and 10 waiting time.\nPricing may vary based on your locality. Book Porter 2 wheeler now!"
            }
        },
        {
            "id": 3,
            "display_name": "Canter 14ft",
            "vehicle_type": "Tata 407 14ft",
            "geo_region": {
                "id": 3,
                "name": "Bangalore"
            },
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/canter_14ft-e90b94fb3bffacd6d30fa80c63256dfb38033266674f2f5f0739d6c4de2fe5a6.png",
            "image_alt_text": "Mini Truck Canter 14ft in Bangalore",
            "vehicle_icon_url": "https://oms-staging-1.porter.in//assets/website_revamp/vehicle_icons/canter_14ft-033f8bc44d27032176d886af9c84ff72a754bad2491801b38ce52f53ecf3e512.svg",
            "description": null,
            "capacity": {
                "value": 3500,
                "unit": "kg"
            },
            "capacity_display": "3500kg",
            "size": {
                "length": {
                    "value": 14,
                    "unit": "ft"
                },
                "breadth": {
                    "value": 6,
                    "unit": "ft"
                },
                "height": {
                    "value": 6,
                    "unit": "ft"
                },
                "type": "goods_vehicle"
            },
            "size_display": "14ft x 6ft x 6ft",
            "base_fare": {
                "value": 100,
                "currency": "rupee"
            },
            "base_fare_display": "₹100",
            "free_time_distance_text": "Base fare includes 1.0 km distance and 5 minutes of time",
            "url": null,
            "css_class": "canter_14ft",
            "rental_package": null,
            "snippet_details": null
        },
        {
            "id": 8,
            "display_name": "Pickup 8ft",
            "vehicle_type": "Pickup / 8ft",
            "geo_region": {
                "id": 3,
                "name": "Bangalore"
            },
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/pickup_8ft-5daaf8cf8ab115b87e6ead485301f032ae8722c594537af99b45732905087eed.png",
            "image_alt_text": "Mini Truck Pickup 8ft in Bangalore",
            "vehicle_icon_url": "https://oms-staging-1.porter.in//assets/website_revamp/vehicle_icons/pickup_8ft-cbc8159d01dc1efea6b0631f8cce8bbee1dcf7b446d2df6516d8215ff6833082.svg",
            "description": null,
            "capacity": {
                "value": 1250,
                "unit": "kg"
            },
            "capacity_display": "1250kg",
            "size": {
                "length": {
                    "value": 8,
                    "unit": "ft"
                },
                "breadth": {
                    "value": 4.5,
                    "unit": "ft"
                },
                "height": {
                    "value": 5.5,
                    "unit": "ft"
                },
                "type": "goods_vehicle"
            },
            "size_display": "8ft x 4.5ft x 5.5ft",
            "base_fare": {
                "value": 44,
                "currency": "rupee"
            },
            "base_fare_display": "₹44",
            "free_time_distance_text": "Base fare includes 2.0 km distance and 2 minutes of time",
            "url": "/rent-mini-trucks-in-bangalore/pickup-8ft",
            "css_class": "pickup_8ft",
            "rental_package": null,
            "snippet_details": null
        },
        {
            "id": 9,
            "display_name": "Pickup 8ft ( id 9)",
            "vehicle_type": "Pickup / Dost / Super Ace / 8ft",
            "geo_region": {
                "id": 3,
                "name": "Bangalore"
            },
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_ace_closed-e92a36b3508e6e3b1804fd2015adbfb6c948bc35afab36699440785ed83b5b24.png",
            "image_alt_text": "Mini Truck Pickup 8ft ( id 9) in Bangalore",
            "vehicle_icon_url": "https://oms-staging-1.porter.in//assets/website_revamp/vehicle_icons/tata_ace-0ef1cc8a772e4180aa010c40bf34202934ab66bbbfd00f241f8182acc70cac59.svg",
            "description": "Want to send your business goods within Bengaluru? Porter is your friend. Rent a 8ft pickup tempo truck & get your commercial goods delivered safely & smoothly. With Porter, you would be able to rent the services at the best truck bhada and transport goods of all sizes & weight.\nFrom industrial machinery to home appliances, the 8ft pickup truck will have space for all commercial and local goods. These rental trucks will not only help you in moving your goods & packages but will also help you in shifting your home from one place to another within the city.\nIt’s time for you to book Porter and worry not about any of your logistics requirements.",
            "capacity": {
                "value": 1250,
                "unit": "kg"
            },
            "capacity_display": "1250kg",
            "size": {
                "length": {
                    "value": 8,
                    "unit": "ft"
                },
                "breadth": {
                    "value": 4.5,
                    "unit": "ft"
                },
                "height": {
                    "value": 5.5,
                    "unit": "ft"
                },
                "type": "goods_vehicle"
            },
            "size_display": "8ft x 4.5ft x 5.5ft",
            "base_fare": {
                "value": 300,
                "currency": "rupee"
            },
            "base_fare_display": "₹300",
            "free_time_distance_text": "Base fare includes 2.0 km distance and 10 minutes of time",
            "url": "/rent-mini-trucks-in-bangalore/pickup-8ft",
            "css_class": "pickup_8ft_(_id_9)",
            "rental_package": null,
            "snippet_details": {
                "heading_text": "Transport rate for Pickup / Dost / Super Ace / 8ft in Bangalore",
                "content": "Get tempo bhada for your intra city, inter city or outstation goods delivery even before you book a truck. Get best moving prices per km and per day using Porter app. Base rate starts from ₹300, which includes 2.0 km distance and 10 waiting time.\nPricing may vary based on your locality. GST charges, road tax & parking etc are applicable over and above the ride fare.\nDownload the Porter app & get the exact transportation charges!"
            }
        },
        {
            "id": 2,
            "display_name": "Tata 407",
            "vehicle_type": "Tata 407",
            "geo_region": {
                "id": 3,
                "name": "Bangalore"
            },
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_407-b968c07406c8b63fca431ef8ea2152caf5272b0013502a73d2390289f1138505.png",
            "image_alt_text": "Mini Truck Tata 407 in Bangalore",
            "vehicle_icon_url": "https://oms-staging-1.porter.in//assets/website_revamp/vehicle_icons/tata_407-dae10ff433ebd205c69c88ba77da6bf369a419212d7224f55a05cf59fabbec82.svg",
            "description": "We’re all familiar with Bangalore, so why not sit back and book Porter’s Tata 407 tempo truck online. The truck rental service will help you in house shifting, transporting your commercial goods or even in delivering your home appliances. When one vehicle can carry so many goods and that too at the lowest & best bhada charges, it's an opportunity not to be missed. So download the app now and rent Tata 407 to help you with all your logistics needs.",
            "capacity": {
                "value": 2500,
                "unit": "kg"
            },
            "capacity_display": "2500kg",
            "size": {
                "length": {
                    "value": 9,
                    "unit": "ft"
                },
                "breadth": {
                    "value": 5.5,
                    "unit": "ft"
                },
                "height": {
                    "value": 6,
                    "unit": "ft"
                },
                "type": "goods_vehicle"
            },
            "size_display": "9ft x 5.5ft x 6ft",
            "base_fare": {
                "value": 500,
                "currency": "rupee"
            },
            "base_fare_display": "₹500",
            "free_time_distance_text": "Base fare includes 1.0 km distance and 100 minutes of time",
            "url": "/rent-mini-trucks-in-bangalore/tata-407",
            "css_class": "tata_407",
            "rental_package": null,
            "snippet_details": {
                "heading_text": "Transport rate for Tata 407 in Bangalore",
                "content": "At Porter we provide you with transparent Tata 407 truck rental costs. Now you longer need to find a low cost tempo bhada at the naka, but you can confirm your moving truck rental prices at the click of a button. Download the Porter app & get the exact transportation charges! Pricing may vary based on your locality. GST charges, road tax & parking etc are applicable over and above the ride fare.Base rate starts from ₹500, which includes 1.0 km distance and 100 minutes waiting time."
            }
        },
        {
            "id": 125,
            "display_name": "Ace (Helper + 1 Labour)",
            "vehicle_type": "Ace Helper + 1 Labour",
            "geo_region": {
                "id": 3,
                "name": "Bangalore"
            },
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_ace_closed-e92a36b3508e6e3b1804fd2015adbfb6c948bc35afab36699440785ed83b5b24.png",
            "image_alt_text": "Mini Truck Ace (Helper + 1 Labour) in Bangalore",
            "vehicle_icon_url": "https://oms-staging-1.porter.in//assets/website_revamp/vehicle_icons/tata_ace-0ef1cc8a772e4180aa010c40bf34202934ab66bbbfd00f241f8182acc70cac59.svg",
            "description": null,
            "capacity": {
                "value": 750,
                "unit": "kg"
            },
            "capacity_display": "750kg",
            "size": {
                "length": {
                    "value": 7,
                    "unit": "ft"
                },
                "breadth": {
                    "value": 4.5,
                    "unit": "ft"
                },
                "height": {
                    "value": 5.5,
                    "unit": "ft"
                },
                "type": "goods_vehicle"
            },
            "size_display": "7ft x 4.5ft x 5.5ft",
            "base_fare": {
                "value": 200,
                "currency": "rupee"
            },
            "base_fare_display": "₹200",
            "free_time_distance_text": "Base fare includes 1.0 km distance and 70 minutes of time",
            "url": null,
            "css_class": "ace_(helper_+_1_labour)",
            "rental_package": null,
            "snippet_details": null
        }
    ],
    "city_zones_text": "Whether it’s Central, Hosur road, Banashankari, Yeshwanthpur, Peenya, Marathahalli, Nagwara, Varthur, Yelahanka, Basavangudi, Sampanji Ramnagar, BTM, Kormangala, Banshankari, Yeshwanthpur, HSR, Marathahalli, Jayanagar, JP Nagar, Peenya, Nagawara 1, Indiranagar, Malleshwaram, Mahadevpura, Shivajinagar, Ramamurthy nagar, Sanjaynagar, Begur, Bellandur, Baiyyappanahalli, Nagawara 2, Vijaynagar, Nagarbhavi, Choodasandra, Kumaraswamy Layout, Electronic city Phase 1 or any other area, Porter is there for you.",
    "offers": [
        {
            "title": "Testing circuitbox",
            "description": null,
            "campaign_type": "discount",
            "coupon_code": "CIRCUITBOX",
            "validity_text": "Coupon code CIRCUITBOX is valid till 2022-11-10",
            "thumbnail_image_link": "https://s3-ap-southeast-1.amazonaws.com/porter-website-banners/prod/cashback_offer_images/cashback_images/thumbnail_banner.png",
            "thumbnail_image_alt_text": "Porter discount offer",
            "offer_details_url": "https://oms-staging-1.porter.in/offers/discount/porter844campaign"
        },
        {
            "title": "Coupon 1",
            "description": null,
            "campaign_type": "discount",
            "coupon_code": "FPT_C1",
            "validity_text": "Coupon code FPT_C1 is valid till 2022-11-30",
            "thumbnail_image_link": "https://s3-ap-southeast-1.amazonaws.com/porter-website-banners/prod/cashback_offer_images/cashback_images/thumbnail_banner.png",
            "thumbnail_image_alt_text": "Porter discount offer",
            "offer_details_url": "https://oms-staging-1.porter.in/offers/discount/porter834campaign"
        }
    ],
    "outstation_content": [
        {
            "route": "Bangalore to Ramanagara",
            "fare": {
                "value": 1300,
                "currency": "rupee"
            },
            "fare_display": "₹1300"
        },
        {
            "route": "Bangalore to Chikkaballapura",
            "fare": {
                "value": 1600,
                "currency": "rupee"
            },
            "fare_display": "₹1600"
        },
        {
            "route": "Bangalore to Krishnagiri",
            "fare": {
                "value": 2700,
                "currency": "rupee"
            },
            "fare_display": "₹2700"
        },
        {
            "route": "Bangalore to Anantapur",
            "fare": {
                "value": 3900,
                "currency": "rupee"
            },
            "fare_display": "₹3900"
        },
        {
            "route": "Bangalore to Chamrajnagar",
            "fare": {
                "value": 4600,
                "currency": "rupee"
            },
            "fare_display": "₹4600"
        },
        {
            "route": "Bangalore to Chitradurga",
            "fare": {
                "value": 5600,
                "currency": "rupee"
            },
            "fare_display": "₹5600"
        },
        {
            "route": "Bangalore to Mysore",
            "fare": {
                "value": 4200,
                "currency": "rupee"
            },
            "fare_display": "₹4200"
        },
        {
            "route": "Bangalore to Hassan",
            "fare": {
                "value": 5600,
                "currency": "rupee"
            },
            "fare_display": "₹5600"
        },
        {
            "route": "Bangalore to Salem",
            "fare": {
                "value": 5800,
                "currency": "rupee"
            },
            "fare_display": "₹5800"
        },
        {
            "route": "Bangalore to Tumkur",
            "fare": {
                "value": 2100,
                "currency": "rupee"
            },
            "fare_display": "₹2100"
        },
        {
            "route": "Bangalore to Kolar",
            "fare": {
                "value": 2000,
                "currency": "rupee"
            },
            "fare_display": "₹2000"
        },
        {
            "route": "Bangalore to Mandya",
            "fare": {
                "value": 3000,
                "currency": "rupee"
            },
            "fare_display": "₹3000"
        }
    ]
};

function getVehicleInfo(city_name) {
  Logger$Catalyst.trace({
        requestUrl: "getVehicleInfoApiCalled"
      });
  Logger$Catalyst.debug({
        payload: city_name
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyCityResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TrackLiveTripRepoConfig.VehicleOmsResponseConverter.execute, result);
                            });
                }), "");
}

export {
  dummyTrackLiveTripInfo ,
  dummyMarketingInfo ,
  fetchTrackLiveTripInfo ,
  fetchTrackLiveTripMarketingInfo ,
  dummyCityResponse ,
  getVehicleInfo ,
  
}
/* NetworkUtils Not a pure module */
